// PW TOOLS JS FRONT
window.showMessage = showMessage

// INPUT FILE CUSTOM
var inputFileItems = document.querySelectorAll('.input-file')

for (var i = 0; i < inputFileItems.length; i++) {
    var fileInput = inputFileItems[i].children[0],
        button = inputFileItems[i].children[1],
        the_return = inputFileItems[i].children[2]

    button.addEventListener('keydown', function (event) {
        if (event.keyCode == 13 || event.keyCode == 32) {
            this.previousElementSibling.focus()
        }
    })

    button.addEventListener('click', function (event) {
        this.previousElementSibling.focus()
        return false
    })

    fileInput.addEventListener('change', function (event) {
        var this_return = this.nextElementSibling.nextElementSibling
        this_return.innerHTML = this.value.replace('C:\\fakepath\\', ' ')
    })
} // END

// Fonction qui affiche une notification en bas du header pendant 3 secondes
// type : ( string ) class qu'aura l'élément ajouté ( valid, error ou delete )
// message : ( string ) message affiché
function showMessage(type, message) {
    var alert = $('<p>')
    alert.addClass('msg-info flash')
    alert.addClass(type)
    alert.html(message)

    $('body').append(alert)

    setTimeout(function () {
        alert.addClass('open')
    }, 100)

    setTimeout(function () {
        alert.removeClass('open')
    }, 3000)

    setTimeout(function () {
        alert.remove()
    }, 3500)
}

function scrollToGo(selector) {
    if (selector.length) {
        if ($('sidebar-toggle').hasClass("is-open")) {
            $('.sidebar-toggle').removeClass("is-open");
        }

        $("html, body").animate({ scrollTop: $(selector).offset().top - ($('header').height()-1) }, 1000);
    }
}

$(document).ready(function () {
    // RETOUR EN HAUT - créer balise #gotop
    $('#gotop').on('click', function () {
        //
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return false
    })

    // BOUTON TOGGLE MAIN NAV
    $('.toggle-nav').click(function () {
        $(this).toggleClass('menu-open')
        $('.menu').toggleClass('showing-nav')
        $('.top-header').toggleClass('menu-open')
        $('.logo').toggleClass('switch')
        return false
    })

    // BOUTON TOGGLE SEARCH
    $('.toggle-search').click(function () {
        $(this).toggleClass('search-mobile-on')
        $('.form-search').toggleClass('search-open')
        return false
    })

    // SCROLL TO
    $('a[href^="#"]').on('click', function() {
        let selector = $(this).attr('href')
        scrollToGo(selector)
    })

    // POPUP
    $('*[data-popup]').click(function () {
        let popup = $('#' + $(this).attr('data-popup'))

        $('body').addClass('mode-popup')
        popup.addClass('open')

        $(document).mouseup(function(e){
            if (!popup.is(e.target) && popup.has(e.target).length === 0)
            {
                popup.removeClass('open')
                $('body').removeClass('mode-popup')
            }
        });
    })

    // CLOSE POPUP
    $('.close-popup').click(function () {
        $('body').removeClass('mode-popup')
        $(this).parent('.popup').removeClass('open')
    })

    // ONGLETS
    $('*[data-onglet]').click(function () {
        $('.nav-onglets > a').removeClass('actif')
        $('.onglet-content').removeClass('open')
        $(this).addClass('actif')
        $('#' + $(this).attr('data-onglet')).addClass('open')

        document.querySelectorAll('.youtube-player').forEach(function (el) {
            console.log(el)
            el.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
        })

    })

    $('*[data-onglet-text]').click(function () {
        $(this).parent().find('a').removeClass('actif')
        $(this).addClass('actif')
        $('.onglet-text').removeClass('open')
        $('.onglet-video').removeClass('open')
        $('#' + $(this).attr('data-onglet-text')).addClass('open')
        $('.' + $(this).attr('data-onglet-text')).addClass('open')
    })

    // TOGGLE SECTION
    $('.toggle-item').on('click', '> .toggle-launcher', function () {
        if ($(this).parent().hasClass('open')) {
            $(this).parent().removeClass('open')
        } else {
            $(this).parents('.toggle-section').find('.toggle-item.open').removeClass('open')
            $(this).parent().addClass('open')
        }

        return false
    })

    // RECUP EMAIL NEWSLETTER POPUP
    $('[data-popup-news="inscrinews"]').on('click', function () {
        if ($('#recup-email-news:valid').length != 0) {
            var email = $('#recup-email-news').val()
            $('#email-newsletter').attr('value', email)
            $('body').addClass('mode-popup')
            $('#' + $(this).attr('data-popup-news')).addClass('open')
        }
    })

    //Select custom :
    $('.select-custom select').each(function () {
        const dropdown = $('<div />').addClass('dropdown selectDropdown')

        $(this).wrap(dropdown)

        const label = $('<span />').text($(this).attr('placeholder')).insertAfter($(this))
        const list = $('<ul class="list-select" />')

        $(this)
            .find('option')
            .each(function () {
                list.append($('<li />').append($('<a />').text($(this).text())))
            })

        list.insertAfter($(this))

        if ($(this).find('option:selected').length) {
            label.text($(this).find('option:selected').text())
            list.find('li:contains(' + $(this).find('option:selected').text() + ')').addClass('active')
            $(this).parent().addClass('filled')
        }
    })

    $(document).on('click touch', '.selectDropdown ul li a', function (e) {
        e.preventDefault()
        const dropdown = $(this).parent().parent().parent()
        const active = $(this).parent().hasClass('active')
        const label = active ? dropdown.find('select').attr('placeholder') : $(this).text()

        dropdown.find('option').prop('selected', false)
        dropdown.find('ul li').removeClass('active')

        dropdown.toggleClass('filled', !active)
        dropdown.children('span').text(label)

        if (!active) {
            dropdown.find('option:contains(' + $(this).text() + ')').prop('selected', true)
            $(this).parent().addClass('active')
        }

        dropdown.removeClass('open')
    })

    $('.dropdown > span').on('click touch', function (e) {
        const self = $(this).parent()
        self.toggleClass('open')
    })

    $(document).on('click touch', function (e) {
        const dropdown = $('.dropdown')
        if (dropdown !== e.target && !dropdown.has(e.target).length) {
            dropdown.removeClass('open')
        }
    })

    $('.open-search').click(function () {
        $('.form-search').addClass('open')
        $('#search_bar_client').focus()
    })

    $('.close-search').click(function () {
        $('.form-search').removeClass('open')
    })

    $('.link-to-go').click(function (event) {
        event.preventDefault()
        let url = $(this).attr('data-href')
        window.open(url)
    })

    $('.filter-button').click(function () {
        $('.sidebar').toggleClass('open')
    })

    const scrollToTopButton = document.getElementById('js-top');

    if(scrollToTopButton != null){
        const scrollFunc = () => {
            let y = window.scrollY;

            if (y > (window.innerHeight)) {
                scrollToTopButton.className = "top-link show";
            } else {
                scrollToTopButton.className = "top-link hide";
            }
        };

        window.addEventListener("scroll", scrollFunc);

        const scrollToTop = () => {
            const c = document.documentElement.scrollTop;

            if (c > 0) {
                window.requestAnimationFrame(scrollToTop);
                window.scrollTo(0, c - c / 5);
            }
        };

        scrollToTopButton.onclick = function(e) {
            e.preventDefault();
            scrollToTop();
        }
    }

    const seeSiteComponent = document.querySelector('.sidelinks')

    const bgDarkChangeColorsHeader = () => {
        document.querySelector('header .logo').classList.toggle('switch')
        document.querySelector('header .toggle-nav').classList.toggle('white')
    }

    const bgDarkChangeColorSeeSite = () => {
        seeSiteComponent.classList.toggle('white')
    }

    gsap.utils.toArray(".bg-dark").forEach((bgDark) => {
        gsap.to(".bg-dark", {
            scrollTrigger: {
                trigger: bgDark,
                start: "top-=50px",
                end: "bottom-=50px",
                onEnter: bgDarkChangeColorsHeader,
                onLeaveBack: bgDarkChangeColorsHeader,
                onLeave: bgDarkChangeColorsHeader,
                onEnterBack: bgDarkChangeColorsHeader
            }
        });
    });

    if(typeof(seeSiteComponent) != 'undefined' && seeSiteComponent != null){
        gsap.utils.toArray(".bg-dark").forEach((bgDark) => {
            gsap.to(".bg-dark", {
                scrollTrigger: {
                    trigger: bgDark,
                    start: "top-=200px",
                    end: "bottom-=50px",
                    onEnter: bgDarkChangeColorSeeSite,
                    onLeaveBack: bgDarkChangeColorSeeSite,
                    onLeave: bgDarkChangeColorSeeSite,
                    onEnterBack: bgDarkChangeColorSeeSite
                }
            });
        });
    }

    options = {
        "cursorOuter": "circle-basic",
        "hoverEffect": "circle-move",
        "hoverItemMove": false,
        "defaultCursor": false,
        "outerWidth": 30,
        "outerHeight": 30
          };
        magicMouse(options);

        $(".bg-dark").on("mouseenter", function() {
            $('#magicMouseCursor').addClass("white");
            $('#magicPointer').addClass("white");

        });

        $(".bg-dark").on("mouseleave", function() {
            $('#magicMouseCursor').removeClass("white");
            $('#magicPointer').removeClass("white");

        });


        document.querySelectorAll("a").forEach(link =>
            link.addEventListener("mouseenter", () => document.querySelector('#magicMouseCursor').classList.toggle("big"))
          )
          document.querySelectorAll("a").forEach(link =>
            link.addEventListener("mouseleave", () => document.querySelector('#magicMouseCursor').classList.toggle("big"))
          )

          $('.menu a').click(function(){
            $('.menu').removeClass('showing-nav');
            $('.toggle-nav').removeClass('menu-open');
          })
}) // FIN DOCUMENT READY
